import { Box } from "@mui/material";
import { ChipLink } from "../../01-atoms/ChipLink/ChipLink";
import { ChipStackProps } from "./ChipStackInterfaces";
import { useChipStackStyles } from "./ChipStackStyles";

export const ChipStack = ({
  chips,
  className,
}: ChipStackProps): JSX.Element => {
  const { classes, cx } = useChipStackStyles();

  return (
    <Box className={cx(classes.wrapper, className)}>
      {chips.map((chip) => {
        return <ChipLink key={chip.label} {...chip} className={classes.chip} />;
      })}
    </Box>
  );
};
